import React from "react";

export function HackerNoonLogo({color = "#00FF00", className = "", width, height}) {
  return (
    <svg
      {...(width ? {width} : {})}
      {...(height ? {height} : {})}
      className={className}
      viewBox="0 0 2150 260"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      style={{transition: "fill 150ms ease"}}
    >
      <g style={{transition: "fill 150ms ease"}}>
        <path
          d="M269.997 20.0005V0H130V20.0005V40.0011V60.0016H150H169.995V40.0011H189.995H229.996V60.0016H249.997H269.997V40.0011V20.0005Z"
          fill={color}
        />
        <path d="M130.006 80.003V60.0024H110.006V80.003V100.004H130.006V80.003Z" fill={color} />
        <path d="M110 119.998V100.003H90V119.998V139.998V159.999H110V139.998V119.998Z" fill={color} />
        <path d="M270 100.004H290V80.003V60.0024H270V80.003V100.004Z" fill={color} />
        <path d="M310 119.997V100.002H290V119.997V139.998V159.998H310V139.998H330.001V119.997H310Z" fill={color} />
        <path d="M130 159.998H110V179.998V199.999H130V179.998V159.998Z" fill={color} />
        <path d="M270 179.998V199.999H290V179.998V159.998H270V179.998Z" fill={color} />
        <path
          d="M130 260V240V219.999V199.999H150H169.995V219.999H189.995H209.996H229.996V199.999H249.997H269.997V219.999V240V260H130Z"
          fill={color}
        />
        <path
          d="M210.415 39.74V59.7405V79.7411V99.7416V119.736V139.737H190.415V119.736V99.7416V79.7411V59.7405V39.74H210.415Z"
          fill={color}
        />
        <path d="M390 200V60H417.801V116.676H501.206V60H530V200H501.206V144.517H417.801V200H390Z" fill={color} />
        <path
          d="M672.199 116.676V88.8352H588.794V116.676H672.199ZM560 200V60H700V200H672.199V144.517H588.794V200H560Z"
          fill={color}
        />
        <path d="M730 200V60H870V88.8352H758.794V172.159H870V200H730Z" fill={color} />
        <path
          d="M900 200V60H928.794V116.276H984.397V143.724H928.794V200H900ZM1012.2 171.368H984.397V143.724H1012.2V171.368ZM1012.2 171.368H1040V199.013H1012.2V171.368ZM1012.2 88.6319V116.276H984.397V88.6319H1012.2ZM1012.2 88.6319V60H1040V88.6319H1012.2Z"
          fill={color}
        />
        <path
          d="M1070 200V60H1210V88.8352H1098.79V116.676H1154.4V144.517H1098.79V172.159H1210V200H1070Z"
          fill={color}
        />
        <path
          d="M1351.24 116.519V88.7589H1267.76V116.519H1351.24ZM1240 200V60H1380V144.479H1351.24V172.24H1380V200H1351.24V172.24H1323.48V144.479H1267.76V200H1240Z"
          fill={color}
        />
        <path d="M1410 200V60H1550V200H1522.24V88.7589H1438.76V200H1410Z" fill={color} />
        <path d="M1692.24 172.24V88.7589H1608.76V172.24H1692.24ZM1580 200V60H1720V200H1580Z" fill={color} />
        <path d="M1862.04 172.24V88.7589H1778.97V172.24H1862.04ZM1750 200V60H1890V200H1750Z" fill={color} />
        <path d="M1920 200V60H2060V200H2032.24V88.7589H1948.76V200H1920Z" fill={color} />
      </g>
    </svg>
  );
}

export default HackerNoonLogo;
